import React from 'react';
import { cn } from '@/utils/cn';

// Simple HTML select wrapper component
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  variant?: 'default' | 'small';
  error?: boolean;
  children: React.ReactNode;
}

export const Select: React.FC<SelectProps> = ({
  variant = 'default',
  error = false,
  className,
  children,
  ...props
}) => {
  const baseClasses = variant === 'small' ? 'form-select-sm' : 'form-select';
  const errorClasses = error ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : '';

  return (
    <select
      className={cn(baseClasses, errorClasses, className)}
      {...props}
    >
      {children}
    </select>
  );
};

interface SelectOptionProps {
  value: string | number;
  children: React.ReactNode;
}

export const SelectOption: React.FC<SelectOptionProps> = ({ value, children }) => {
  return <option value={value}>{children}</option>;
};

// Compound component export
Select.Option = SelectOption;
